// @flow
import type { Map } from "immutable"

import Place from "common/records/Place"
import type { StarredPlaces } from "common/records/Starred.types"

// eslint-disable-next-line import/prefer-default-export
export const resolveTripPlaceData = (tripPlace: Map, starredPlaces: StarredPlaces) => {
  const placeId = tripPlace.get("id")

  return (
    starredPlaces[placeId] ||
    new Place({
      name: tripPlace.get("name"),
      code: tripPlace.get("code"),
    })
  )
}
